import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FeedbackService } from '@mp-core/services/feedback.service';
import { AlertService } from '@mp-core/services/alert.service';
import { MatDialogRef } from '@angular/material/dialog';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'mp-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss'],
})
export class FeedbackDialogComponent implements OnInit {

  name: FormControl;
  email: FormControl;
  suggestion: FormControl;
  isLoading = false;

  constructor(private feedbackService: FeedbackService, private alertService: AlertService, private matDialogRef: MatDialogRef<FeedbackDialogComponent>) {
  }

  ngOnInit() {
    this.email = new FormControl('', [Validators.required, Validators.email]);
    this.name = new FormControl('', [Validators.required]);
    this.suggestion = new FormControl('', [Validators.required]);
  }

  onSubmit() {
      this.isLoading = true;
      this.feedbackService.submitFeedback({
        email: this.email.value,
        name: this.name.value,
        suggestion: this.suggestion.value,
      }).subscribe((res) => {
        console.log(res);
        this.isLoading = false;
        this.alertService.success('Thank you for your feedback!!');
        this.matDialogRef.close();
      }, error => {
        console.log(error);
        this.isLoading = false;
      });
    }
}
